import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchInventory, updateInventory, type InventoryParams } from '@/lib/api';

export function useInventory(params: InventoryParams = {}) {
  return useQuery({
    queryKey: ['inventory', params],
    queryFn: () => fetchInventory(params),
    placeholderData: (prev) => prev,
    staleTime: 10_000,
  });
}

export function useUpdateInventory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      inventoryItemId,
      available,
      locationId,
    }: {
      inventoryItemId: number;
      available: number;
      locationId: number;
    }) => updateInventory(inventoryItemId, { available, location_id: locationId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['inventory'] });
      queryClient.invalidateQueries({ queryKey: ['product'] });
    },
  });
}
